import { MapPin, Camera } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

interface ConsentGateProps {
  consentType: 'geo' | 'photo';
  onGrant: () => void;
}

const CONSENT_CONFIG = {
  geo: {
    icon: MapPin,
    title: 'Localização necessária',
    body: 'Para registrar o ponto, precisamos confirmar sua localização.',
    cta: 'Permitir localização',
  },
  photo: {
    icon: Camera,
    title: 'Câmera necessária',
    body: 'Este acordo exige uma foto no momento do registro.',
    cta: 'Permitir câmera',
  },
} as const;

export function ConsentGate({ consentType, onGrant }: ConsentGateProps) {
  const cfg = CONSENT_CONFIG[consentType];
  const Icon = cfg.icon;

  return (
    <div
      className="flex min-h-dvh flex-col items-center justify-center bg-slate-50 px-8"
      role="dialog"
      aria-modal="true"
      aria-labelledby="consent-title"
    >
      <Card className="w-full max-w-sm">
        <CardContent className="text-center">
          <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-slate-100">
            <Icon className="h-8 w-8 text-slate-700" aria-hidden="true" />
          </div>
          <h2 id="consent-title" className="mb-3 text-lg font-bold text-slate-900">
            {cfg.title}
          </h2>
          <p className="mb-8 text-sm leading-relaxed text-slate-500">{cfg.body}</p>
          <Button size="lg" className="w-full" onClick={onGrant} aria-label={cfg.cta}>
            {cfg.cta}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
